import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    TASK_LIST,
    TASK_DETAIL,
    TASK_DETAIL_LIST,
    TASK_DETAIL_ADD,
    DELIVERY_PLAN_TASK_UPDATE
} from '../actions';
import {
    TaskListSuccess,
    TaskListError,
    TaskDetailSuccess,
    TaskDetailError,
    TaskDetailListSuccess,
    TaskDetailListError,
    TaskDetailAddSuccess,
    TaskDetailAddError,
    DeliveryPlanTaskUpdateSuccess,
    DeliveryPlanTaskUpdateError,
} from '../actions';

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

// LIST
const onTaskListAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onTaskList(action) {
    try {
        const response = yield call(onTaskListAsync, action.payload);
        yield put(TaskListSuccess(response.data));
    } catch (error) {
        yield put(TaskListError(error));
    }
}

// DETAIL (get single task)
const onTaskDetailAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task/detail', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onTaskDetail(action) {
    try {
        const response = yield call(onTaskDetailAsync, action.payload);
        yield put(TaskDetailSuccess(response.data.data));
    } catch (error) {
        yield put(TaskDetailError(error));
    }
}

// TASK DETAIL LIST (chat messages)
const onTaskDetailListAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task/detail-list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onTaskDetailList(action) {
    try {
        const response = yield call(onTaskDetailListAsync, action.payload);
        yield put(TaskDetailListSuccess(response.data.data));
    } catch (error) {
        yield put(TaskDetailListError(error));
    }
}

// TASK DETAIL ADD (send chat message)
const onTaskDetailAddAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task/detail-add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onTaskDetailAdd(action) {
    try {
        const response = yield call(onTaskDetailAddAsync, action.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else {
            NotificationManager.error(response.data.message || 'Error', 'Error', 3000, null, null, '');
        }
        yield put(TaskDetailAddSuccess(response.data.id));
    } catch (error) {
        yield put(TaskDetailAddError(error));
        NotificationManager.error('Error al enviar mensaje', 'Error', 3000, null, null, '');
    }
}

function* watchTaskList() { yield takeEvery(TASK_LIST, onTaskList); }
function* watchTaskDetail() { yield takeEvery(TASK_DETAIL, onTaskDetail); }
function* watchTaskDetailList() { yield takeEvery(TASK_DETAIL_LIST, onTaskDetailList); }
function* watchTaskDetailAdd() { yield takeEvery(TASK_DETAIL_ADD, onTaskDetailAdd); }

// DELIVERY PLAN TASK UPDATE
const onDeliveryPlanTaskUpdateAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task/delivery-plan-task/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onDeliveryPlanTaskUpdate(action) {
    try {
        const response = yield call(onDeliveryPlanTaskUpdateAsync, action.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        }
        yield put(DeliveryPlanTaskUpdateSuccess(response.data));
    } catch (error) {
        yield put(DeliveryPlanTaskUpdateError(error));
    }
}

function* watchDeliveryPlanTaskUpdate() { yield takeEvery(DELIVERY_PLAN_TASK_UPDATE, onDeliveryPlanTaskUpdate); }

// DELIVERY PLAN UPDATE (brand, model, origin, serial)
const onDeliveryPlanUpdateAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task/delivery-plan/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};



export default function* rootSaga() {
    yield all([
        fork(watchTaskList),
        fork(watchTaskDetail),
        fork(watchTaskDetailList),
        fork(watchTaskDetailAdd),
        fork(watchDeliveryPlanTaskUpdate)
    ]);
}
